
import { useEffect } from 'react';
import RouterPaths from './common-components/RouterPaths';
import "./static/css/wm-bootstrap.css";
import "./static/css/wm-login-app-styles.css";
import "./static/css/common.css";
import "./static/css/app.css";


function App() {
  useEffect(() => {
    document.getElementById('app-loader')?.remove();
  }, []);

  return (
    <div className="app-page-wrapper">
      <RouterPaths />
    </div>
  );
}

export default App;
